export const REQUEST_PRODUCT_LISTING = 'request-product-listing';
export const REQUEST_PRODUCT_LISTING_ITEMS = 'request-product-listing-items';
export const REQUEST_PRODUCT_LISTING_ITEMS_FORM =
  'request-product-listing-items-form';
export const REQUEST_PRODUCT_LISTING_SUMMARY_ITEMS =
  'request-product-listing-summary-items';
export const REQUEST_PRODUCT_LISTING_SUMMARY_LOG_ITEMS =
  'request-product-listing-summary-log-items';
export const REQUEST_PRODUCT_MODAL_PRODUCT = 'request-product-modal-product';
export const REQUEST_PRODUCT_MODAL_PRODUCT_CATALOG =
  'request-product-modal-product-catalog';
